import * as React from 'react';

import { SliderItem, GetTrackProps } from 'react-compound-slider';

import styled, { css } from 'styled-components';

interface TrackProps {
  className?: string;
  source: SliderItem;
  target: SliderItem;
  invalid: boolean;
  getTrackProps: GetTrackProps;
}

export const Track: React.FC<TrackProps> = (props) => (
  <div
    className={props.className}
    style={{
      left: `${props.source.percent}%`,
      width: `${props.target.percent - props.source.percent}%`,
    }}
    {...props.getTrackProps()}
  />
);

export default styled(Track)`
  position: absolute;
  height: 3px;
  margin-top: -1px;
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.apple};
  background-color: ${(props) =>
    props.invalid
      ? css`
          ${({ theme }) => theme.colors.error}
        `
      : css`
          ${({ theme }) => theme.colors.blueColor}
        `};
  opacity: 0.7;
  border-radius: 8px;
  cursor: pointer;
`;
